import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import CourseCatalog from './pages/CourseCatalog';
import CourseDetails from './pages/CourseDetails';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Register from './pages/Register';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailure from './pages/PaymentFailure';
import AdminPanel from './pages/AdminPanel';
import InternshipCatalog from './pages/InternshipCatalog';
import InternshipDetails from './pages/InternshipDetails';
import InternshipWorkspace from './pages/InternshipWorkspace';
import InternshipPaymentSuccess from './pages/InternshipPaymentSuccess';
import FloatingShapes from './components/FloatingShapes';
import Footer from './components/Footer';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen relative">
          <FloatingShapes />
          
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="relative z-10"
          >
            <Navbar />
            
            <Routes>
              <Route path="/" element={<CourseCatalog />} />
              <Route path="/course/:id" element={<CourseDetails />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/failure" element={<PaymentFailure />} />
              <Route path="/internships" element={<InternshipCatalog />} />
              <Route path="/internships/:id" element={<InternshipDetails />} />
              <Route path="/internships/:id/workspace" element={<InternshipWorkspace />} />
              <Route path="/internship/payment/success/:id" element={<InternshipPaymentSuccess />} />
            </Routes>
            <Footer />
          </motion.div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
